import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { DEFAULT_EMPTY_VALUE } from '../../../../../constants/strings';

import styles from '../styles.styl';

const EirVisitView = ({
  service,
  reasonType,
  paymentDetails,
  providerView,
}) => {
  const { formatMessage } = useIntl();

  return (
    <section className={styles.row}>
      <div className={styles.columnWrapper}>
        <div className={styles.column}>
          <div className={styles.meta}>
            {formatMessage({ id: 'appointment.list.card.service' })}
          </div>
          <div className={styles.meta}>
            {formatMessage({
              id: providerView
                ? 'appointment.list.card.payment'
                : 'appointment.list.card.yourCost',
            })}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.provider}>{service}</div>
          <div className={styles.provider}>{paymentDetails}</div>
        </div>
      </div>
      <div className={styles.columnWrapper}>
        <div className={styles.column}>
          <div className={styles.meta}>
            {formatMessage({
              id: 'appointment.list.card.reasonForVisit',
            })}
          </div>
        </div>
        <div className={styles.column}>
          <div className={styles.provider}>
            {reasonType || DEFAULT_EMPTY_VALUE}
          </div>
        </div>
      </div>
    </section>
  );
};

EirVisitView.propTypes = {
  paymentDetails: PropTypes.string,
  providerView: PropTypes.bool,
  reasonType: PropTypes.string,
  service: PropTypes.string,
};

export default EirVisitView;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentCard/Views/EirVisitView.jsx